import React, { useEffect, useRef, useState } from "react";
import Input from "../UniversalComponents/InputComponent";

import { ReactComponent as DownAngelBracket } from "../../assets/images/downAngleBracket.svg";
import { ReactComponent as CalendarWithTimeIcon } from "../../assets/images/calendarWithTimeIcon.svg";
import Select from "../../components/UniversalComponents/SelectComponent";
import DatePicker from "react-datepicker";
import { ReactComponent as ClosePopUpIcn } from "../../assets/images/closePopUpIcn.svg";
import NameContact from "../../assets/images/icons/NameContact";
import LocationIcon from "../../assets/images/icons/LocationIcon";
import NotesAttachment from "../../assets/images/icons/NotesAttachment";
import BalleteIcon from "../../assets/images/icons/BalleteIcon";
import AdditionalInfoIcon1 from "../../assets/images/icons/AdditionalInfoIcon1";
import Button from "../UniversalComponents/DefaultButton";

const NewVendor = (closeAddVendor) => {
  const [selectedDefaultExCateValue, setSelectedDefaultExCateValue] = useState("");

  const nameTabRef = useRef(null);
  const locationTabRef = useRef(null);
  const notesTabRef = useRef(null);
  const paymentTabRef = useRef(null);
  const additionalInfTabRef = useRef(null);

  const [OpeningBalanceDate, setOpeningBalanceDate] = useState(null);

  const [selectedTermValue, setSelectedTermValue] = useState("");
  const [selectedDeExCatValue, setSelectedDeExCatValue] = useState("");
  const [selectedCountry, setSelectedCountry] = useState("");
  const [isContactFormOpen, setIsContactFormOpen] = useState(false);
  const [isAddressFormOpen, setIsAddressFormOpen] = useState(false);
  const [isPaymentTabOpen, setIsPaymentTabOpen] = useState(false);
  const [isAddiInfoTabOpen, setIsAddiInfoTabOpen] = useState(false);
  const [isAddVendorVisible, setIsAddVendorVisible] = useState(false);

  const placeholder = "Select Date";
  const displayFormat = "dd-MM-yyyy";

  const selectDeExCatName = [
    { value: "option2", label: "Option 2" },
    { value: "option3", label: "Option 3" },
  ];
  const selectCountry = [
    { value: "option2", label: "Option 2" },
    { value: "option3", label: "Option 3" },
  ];

  const handleDeExCatSelectChange = (e) => {
    setSelectedDeExCatValue(e.target.value);
  };
  const handleCountrySelectChange = (e) => {
    setSelectedCountry(e.target.value);
  };

  const toggleVisibility = (e, setState) => {
    e.preventDefault();
    setState((prevState) => !prevState);
  };

  const handleAddAnotherAccount = () => {};
  const handleVendorSave = () => {};
  const handleVendorCancel = () => {};

  const [formData, setFormData] = useState({
    vendorName: "",
    vendorContactName: "",
    email: "",
    phoneNumber: "",
    mobileNumber: "",
    website: "",
    streetAddress1: "",
    streetAddress2: "",
    city: "",
    state: "",
    zipCode: "",
    bankName: "",
    bankAddress: "",
    accountName: "",
    accountNumber: "",
    nameToPrintonCheck: "",
    routingNumber: "",
    businessIDNo_SocialSecurityNo: "",
    account_Number: "",
    openingBalance: "",
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };
  const handleNewVendorClick = () => {
    setIsAddVendorVisible((prev) => !prev); // Toggle visibility
  };

  // useEffect(() => {
  //   if (isNotesOpen) handleNotesScrollToSection();
  // }, [isNotesOpen]);

  useEffect(() => {
    if (isContactFormOpen) handleNameScrollToSection();
  }, [isContactFormOpen]);

  useEffect(() => {
    if (isAddressFormOpen) handleLocationScrollToSection();
  }, [isAddressFormOpen]);

  useEffect(() => {
    if (isPaymentTabOpen) handleBalletScrollToSection();
  }, [isPaymentTabOpen]);

  useEffect(() => {
    if (isPaymentTabOpen) handleBalletScrollToSection();
  }, [isPaymentTabOpen]);

  useEffect(() => {
    if (isAddiInfoTabOpen) handleAdditionalTabScrollToSection();
  }, [isAddiInfoTabOpen]);

  // const closeAddVendor = () => {
  //   setIsAddVendorVisible(false);
  // };

  const selectVendoerDisplayName = [
    // { label: "Who did you Pay ?" },
    { value: "option2", label: "Option 2" },
    { value: "option3", label: "Option 3" },
  ];
  const selectTermName = [
    // { label: "Who did you Pay ?" },
    { value: "option2", label: "Option 2" },
    { value: "option3", label: "Option 3" },
  ];
  const selectDefaultExCategory = [
    // { label: "Who did you Pay ?" },
    { value: "option2", label: "Option 2" },
    { value: "option3", label: "Option 3" },
  ];

  const handleTermSelectChange = (e) => {
    setSelectedTermValue(e.target.value);
  };
  // const handleDefaultExCateSelectChange = (e) => {
  //   setSelectedDefaultExCateValue(e.target.value);
  // };
  // const handleVendorSelectChange = (e) => {
  //   setSelectedValue(e.target.value);
  // };

  const formatDateForSaveAsOf = (date) => {
    if (!date) return "";
    const year = date.getFullYear();
    const month = `${date.getMonth() + 1}`.padStart(2, "0");
    const day = `${date.getDate()}`.padStart(2, "0");
    return `${day}-${month}-${year}`;
  };

  const onChange = (date) => {
    setOpeningBalanceDate(date);

    const formattedPaymentDate = date ? formatDateForSaveAsOf(date) : "";

    // FieldChange({ payment_date: formattedPaymentDate });
  };

  const handleNameScrollToSection = () => {
    nameTabRef?.current?.scrollIntoView({
      behavior: "smooth",
      block: "center",
    });
  };
  const handleLocationScrollToSection = () => {
    locationTabRef?.current?.scrollIntoView({
      behavior: "smooth",
      block: "center",
    });
  };
  const handleNotesScrollToSection = () => {
    notesTabRef?.current?.scrollIntoView({
      behavior: "smooth",
      block: "center",
    });
  };
  const handleBalletScrollToSection = () => {
    paymentTabRef?.current?.scrollIntoView({
      behavior: "smooth",
      block: "center",
    });
  };
  const handleAdditionalTabScrollToSection = () => {
    additionalInfTabRef?.current?.scrollIntoView({
      behavior: "smooth",
      block: "center",
    });
  };

  return (
    <div className="">
      {/* <div>Icons</div> */}
      <div className=" bg-FFFFFF p-6 pl-4">
        <div className="flex justify-between border-b-2 ml-12 pb-2 mb-2">
          <div className="text-20 font-500 text-203C50 align-text-bottom">Vendor</div>
          <div className="bg-F1F5F8 m-1 px-1 align-top">
            <button onClose={closeAddVendor}>
              <ClosePopUpIcn />
            </button>
          </div>
        </div>
        <div className="flex space-x-4 ">
          <div className="flex flex-col space-y-2">
            <button onClick={(e) => toggleVisibility(e, setIsContactFormOpen)} className="btn">
              <NameContact />
            </button>
            <button onClick={(e) => toggleVisibility(e, setIsAddressFormOpen)} className="btn">
              <LocationIcon />
            </button>
            {/* <button
              onClick={(e) => {
                toggleNotesVisibility(e);
              }}
            >
              <NotesAttachment />
            </button> */}
            <button onClick={(e) => toggleVisibility(e, setIsPaymentTabOpen)} className="btn">
              <BalleteIcon />
            </button>
            <button onClick={(e) => toggleVisibility(e, setIsAddiInfoTabOpen)} className="btn">
              <AdditionalInfoIcon1 />
            </button>
          </div>
          <div className="w-[652px] flex flex-col space-y-[20px] h-[90vh] overflow-y-scroll customscrollbar">
            {/* Name & contact */}
            <div className="">
              <div className="flex justify-between items-center bg-E4E6E8 p-3 border">
                <div className="text-16 font-500">Name & contact</div>
                <div>
                  <button onClick={(e) => toggleVisibility(e, setIsContactFormOpen)} className="btn">
                    <DownAngelBracket
                      className={`h-[8px] text-1D4469 sidedownarrow  items-center ${
                        isContactFormOpen ? "" : "rotate-180"
                      }`}
                    />
                  </button>
                </div>
              </div>
              {isContactFormOpen && (
                <div className="p-5 bg-FFFFFF border rounded">
                  <div className="flex flex-col gap-y-[20px]">
                    <div className="w-full flex items-center space-x-4">
                      <div className=" w-full">
                        <Input
                          name="vendorName"
                          label="Vendor Name"
                          placeholder="Enter Vendor Name"
                          value={formData.vendorName}
                          onChange={handleInputChange}
                          style={{ width: "100%", height: "35px" }}
                        ></Input>
                      </div>
                      <div className="w-full flex flex-col gap-y-1">
                        <Input
                          name="vendorContactName"
                          label="Vendor Display Name"
                          placeholder="Enter Vendor Contact Name"
                          value={formData.vendorContactName} // Bind the input value to the state
                          onChange={handleInputChange} // Handle the change event
                          style={{ width: "100%", height: "35px" }} // Additional styling if needed
                        ></Input>
                      </div>
                    </div>

                    <div className="w-full flex items-center space-x-4">
                      <div className="w-full">
                        <Input
                          name="email"
                          label="Email"
                          placeholder="Enter Email Address"
                          value={formData.email} // Bind the input value to the state
                          onChange={handleInputChange} // Handle the change event
                          style={{ width: "100%", height: "35px" }} // Additional styling if needed
                        ></Input>
                      </div>
                      <div className="w-full">
                        <Input
                          name="phoneNumber"
                          label="Phone Number"
                          type={"number"}
                          placeholder="Enter Phone Number"
                          value={formData.phoneNumber} // Bind the input value to the state
                          onChange={handleInputChange} // Handle the change event
                          style={{ width: "100%", height: "35px" }} // Additional styling if needed
                        ></Input>
                      </div>
                    </div>

                    <div className="w-full flex gap-x-4">
                      <div className="w-full">
                        <Input
                          name="mobileNumber"
                          label="Mobile Number"
                          type={"number"}
                          placeholder="Enter Other Detail"
                          value={formData.mobileNumber}
                          onChange={handleInputChange}
                          style={{ width: "100%", height: "35px" }}
                        ></Input>
                      </div>
                      <div className="w-full">
                        <Input
                          name="website"
                          label="Website"
                          type={""}
                          placeholder="Enter Company Name"
                          value={formData.website}
                          onChange={handleInputChange}
                          style={{ width: "100%", height: "35px" }}
                        ></Input>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>

            {/* Address */}
            <div className="">
              <div className="flex justify-between items-center bg-E4E6E8 p-3 border">
                <div className="text-16 font-500">Addresses</div>
                <div>
                  <button onClick={(e) => toggleVisibility(e, setIsAddressFormOpen)} className="btn">
                    <DownAngelBracket
                      className={`h-[8px] text-1D4469 sidedownarrow  items-center ${
                        isAddressFormOpen ? "" : "rotate-180"
                      }`}
                    />
                  </button>
                </div>
              </div>
              {isAddressFormOpen && (
                <div className="p-3 bg-FFFFFF border rounded">
                  <div className="flex flex-col gap-y-[20px]">
                    <div className="w-full flex items-center space-x-4">
                      <div className=" w-full">
                        <Input
                          name="streetAddress1"
                          label="Street Address 1"
                          placeholder="Enter Address"
                          value={formData.streetAddress1}
                          onChange={handleInputChange}
                          style={{ width: "100%", height: "35px" }}
                        ></Input>
                      </div>

                      <div className=" w-full flex flex-col gap-y-1">
                        <Input
                          name="streetAddress2"
                          label="Street Address 2"
                          placeholder="Enter Address"
                          value={formData.streetAddress2} // Bind the input value to the state
                          onChange={handleInputChange} // Handle the change event
                          style={{ width: "100%", height: "35px" }} // Additional styling if needed
                        ></Input>
                      </div>
                    </div>

                    <div className="w-full flex items-center space-x-4">
                      <div className=" w-full flex flex-col gap-y-1">
                        <Input
                          name="city"
                          label="City"
                          placeholder="Enter City"
                          value={formData.city} // Bind the input value to the state
                          onChange={handleInputChange} // Handle the change event
                          style={{ width: "100%", height: "35px" }} // Additional styling if needed
                        ></Input>
                      </div>
                      <div className=" w-full flex flex-col gap-y-1">
                        <Input
                          name="state"
                          label="State"
                          placeholder="Enter State"
                          value={formData.state} // Bind the input value to the state
                          onChange={handleInputChange} // Handle the change event
                          style={{ width: "100%", height: "35px" }} // Additional styling if needed
                        ></Input>
                      </div>
                    </div>
                    <div className="w-full flex gap-x-4">
                      <div>
                        <Input
                          name="zipCode"
                          label="Zip Code"
                          type={"number"}
                          placeholder="Enter Other Detail"
                          value={formData.zipCode}
                          onChange={handleInputChange}
                          style={{ width: "100%", height: "35px" }}
                        />
                      </div>
                      <div className="flex flex-col gap-y-1 w-full">
                        <div className="text-14 font-400 text-434852">Country</div>
                        <Select
                          name="country"
                          label="Country"
                          placeholder={"Choose An Option"}
                          options={selectCountry} // Pass the options array
                          value={setSelectedCountry} // Bind the selected value to the state
                          onChange={handleCountrySelectChange} // Handle the change event
                          className="w-full"
                        ></Select>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
            {/* <div className="border">
              <div className="flex justify-between items-center bg-E4E6E8 p-3 border">
                <div className="text-16 font-500">Notes & Attachments</div>
                <div>
                  <button
                    onClick={(e) => {
                      toggleNotesVisibility(e);
                    }}
                  >
                    <DownAngelBracket
                      className={`h-[8px] text-1D4469 sidedownarrow  items-center ${isNotesOpen ? "" : "rotate-180"}`}
                    />
                  </button>
                </div>
              </div>
              {isNotesVisible && (
                <div className="p-5" ref={notesTabRef}>
                  <div className="flex flex-col gap-y-[20px]">
                    <div className="w-full flex items-center space-x-4">
                      <div className=" w-full">
                        <div className="flex flex-col gap-y-[8px] w-full">
                          <div className="text-14 font-500 text-434852">Notes</div>

                          <div className="h-[140px] text-14 font-400">
                            <textarea
                              rows="6"
                              cols="80.5"
                              placeholder=""
                              className="focus:outline-hidden focus:ring-0 active:border active:border-DFE2E5 text-gray-800 text-sm  rounded border border-gray-200"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="w-full flex items-center space-x-4">
                      <div className=" w-full">
                        <div className="flex flex-col gap-y-[8px] w-full">
                          <div className="text-14 font-500 text-434852">Attachments</div>

                          <div className="h-[140px] text-14 font-400 border border-DFE2E5 border-dashed rounded flex items-center justify-center">
                            <button className="text-12 font-400 flex flex-col items-center justify-center text-center">
                              <span className="text-2999BC">Add Attachments</span>
                              <span className="text-AFAFAF">Max File Size: 20 MB</span>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div> */}
            <div className="">
              <div className="flex justify-between items-center bg-E4E6E8 p-3 border">
                <div className="text-16 font-500">Payments</div>
                <div>
                  <button onClick={(e) => toggleVisibility(e, setIsPaymentTabOpen)} className="btn">
                    <DownAngelBracket
                      className={`h-[8px] text-1D4469 sidedownarrow  items-center ${
                        isPaymentTabOpen ? "" : "rotate-180"
                      }`}
                    />
                  </button>
                </div>
              </div>
              {isPaymentTabOpen && (
                <div className="p-5 bg-FFFFFF border rounded">
                  <div className="flex flex-col gap-y-[20px]">
                    <div className="w-full flex items-center space-x-4">
                      <div className=" w-full">
                        <div className="flex flex-col gap-y-1">
                          <div className="text-14 font-400 text-434852">Bank Name</div>

                          <div>
                            <Input
                              name="bankName"
                              label="Enter Bank Name"
                              placeholder="Enter Vendor Name"
                              value={formData.bankName}
                              onChange={handleInputChange}
                              style={{ width: "100%", height: "35px" }}
                            ></Input>
                          </div>
                        </div>
                      </div>
                      <div className="w-full flex flex-col gap-y-1">
                        <div className="text-14 font-400 text-434852">Bank Address</div>
                        <div className="w-full">
                          <Input
                            name="bankAddress"
                            label=""
                            placeholder="Enter Bank Address"
                            value={formData.bankAddress} // Bind the input value to the state
                            onChange={handleInputChange} // Handle the change event
                            style={{ width: "100%", height: "35px" }} // Additional styling if needed
                          ></Input>
                        </div>
                      </div>
                    </div>
                    <div className="w-full flex gap-x-4">
                      <div className="w-full flex flex-col gap-y-1">
                        <div className="text-14 font-400 text-434852">Account Name</div>
                        <div className="w-full">
                          <Input
                            name="accountName"
                            placeholder="Enter Account Name"
                            value={formData.accountName} // Bind the input value to the state
                            onChange={handleInputChange} // Handle the change event
                            style={{ width: "100%", height: "35px" }} // Additional styling if needed
                          ></Input>
                        </div>
                      </div>
                      <div className="w-full flex flex-col gap-y-1">
                        <div className="text-14 font-400 text-434852">Account Number</div>
                        <div className="w-full">
                          <Input
                            name="accountNumber"
                            placeholder="Enter Account Number"
                            value={formData.accountNumber}
                            onChange={handleInputChange}
                            style={{ width: "100%", height: "35px" }}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="w-full flex gap-x-4">
                      <div className="w-full flex flex-col gap-y-1">
                        <div className="text-14 font-400 text-434852">Name To Print on Check</div>
                        <div className="w-full">
                          <Input
                            name="nameToPrintonCheck"
                            // type={"number"}
                            placeholder="Enter Company Name"
                            value={formData.nameToPrintonCheck}
                            onChange={handleInputChange}
                            style={{ width: "100%", height: "35px" }}
                          ></Input>
                        </div>
                      </div>
                      <div className=" w-full flex flex-col gap-y-1">
                        <div className="text-14 font-400 text-434852">Routing Number</div>

                        <div>
                          <Input
                            name="routingNumber"
                            // label="dkd"
                            type={"number"}
                            placeholder="Enter Routing Number"
                            value={formData.routingNumber}
                            onChange={handleInputChange}
                            style={{ width: "100%", height: "35px" }}
                          ></Input>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
            <div className="">
              <div className="flex justify-between items-center bg-E4E6E8 p-3 border">
                <div className="text-16 font-500">Additional Info</div>
                <div>
                  <button onClick={(e) => toggleVisibility(e, setIsAddiInfoTabOpen)} className="btn">
                    <DownAngelBracket
                      className={`h-[8px] text-1D4469 sidedownarrow  items-center ${
                        isAddiInfoTabOpen ? "" : "rotate-180"
                      }`}
                    />
                  </button>
                </div>
              </div>
              {isAddiInfoTabOpen && (
                <div className="p-5 bg-FFFFFF border rounded">
                  <div className="flex flex-col gap-y-[20px]">
                    <div className="w-full flex items-center space-x-4">
                      <div className=" w-full">
                        <div className="flex flex-col gap-y-1">
                          <div className="text-14 font-600 text-2C495D">Taxes</div>
                        </div>
                      </div>
                    </div>
                    <div className="w-full flex ">
                      <div className=" w-full flex flex-col gap-y-1">
                        <div className="text-14 font-400 text-434852 capitalize">
                          Business ID No. / Social Security No.
                        </div>

                        <div>
                          <Input
                            name="businessIDNo_SocialSecurityNo"
                            // label="dkd"
                            type={"text"}
                            placeholder="Enter ID No."
                            value={formData.businessIDNo_SocialSecurityNo}
                            onChange={handleInputChange}
                            style={{ width: "100%", height: "35px" }}
                          ></Input>
                        </div>
                      </div>
                    </div>
                    <div className="w-full flex ">
                      <div className=" w-full flex  gap-x-1 items-center">
                        <div className="space-x-2">
                          <input
                            type="checkbox"
                            className="appearance-none  text-12 focus:outline-none focus:ring-0 checked:bg-blue-500 checked:border-transparent border-[#D9D9D9]"
                            style={{ boxShadow: "none" }}
                          />

                          <span className="text-[#2C495D] text-12 font-400">Track payments for 1099</span>
                        </div>
                      </div>
                    </div>
                    <div className="w-full flex items-center space-x-4">
                      <div className=" w-full">
                        <div className="flex flex-col gap-y-1">
                          <div className="text-14 font-600 text-2C495D">Payments</div>
                        </div>
                      </div>
                    </div>
                    <div className="w-full flex items-center space-x-4">
                      <div className=" w-full">
                        <div className="flex flex-col gap-y-1">
                          <div className="text-14 font-400 text-434852">Terms</div>

                          <div className="w-full">
                            <Select
                              name="vendordispalyselect"
                              placeholder={"Select Terms"}
                              options={selectTermName} // Pass the options array
                              value={selectedTermValue} // Bind the selected value to the state
                              onChange={handleTermSelectChange} // Handle the change event
                              style={{
                                width: "100%",
                                height: "35px",
                                padding: "5px",
                              }}
                              className="w-full"
                            ></Select>
                          </div>
                        </div>
                      </div>
                      <div className=" w-full flex flex-col gap-y-1">
                        <div className="text-14 font-400 text-434852">Account Number</div>

                        <div>
                          <Input
                            name="account_Number"
                            // label="dkd"
                            placeholder="Enter Account Number"
                            type={"number"}
                            value={formData.account_Number} // Bind the input value to the state
                            onChange={handleInputChange} // Handle the change event
                            style={{ width: "100%", height: "35px" }} // Additional styling if needed
                          ></Input>
                        </div>
                      </div>
                    </div>
                    <div className="w-full flex items-center space-x-4">
                      <div className=" w-full">
                        <div className="flex flex-col gap-y-1">
                          <div className="text-14 font-600 text-2C495D">Accounting</div>
                        </div>
                      </div>
                    </div>
                    <div className="w-full flex ">
                      <div className=" w-full">
                        <div className="flex flex-col gap-y-1">
                          <div className="text-14 font-400 text-434852">Default Expense Category</div>

                          <div className="w-full">
                            <Select
                              name="defaultExpenseCategory"
                              placeholder={"Choose An Option"}
                              options={selectDeExCatName}
                              value={setSelectedDeExCatValue}
                              onChange={handleDeExCatSelectChange}
                              style={{
                                width: "100%",
                                height: "35px",
                                padding: "5px",
                              }}
                              className="w-full"
                            ></Select>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="w-full flex items-center space-x-4">
                      <div className=" w-full">
                        <div className="flex flex-col gap-y-1">
                          <div className="text-14 font-600 text-2C495D">Opening Balance</div>
                        </div>
                      </div>
                    </div>
                    <div className="w-full flex items-center space-x-4">
                      <div className=" w-full">
                        <div className="flex flex-col gap-y-1">
                          <div className="text-14 font-400 text-434852">Opening Balance</div>

                          <div>
                            <Input
                              name="openingBalance"
                              // label="Enter Text"
                              placeholder="00.00"
                              type={"number"}
                              value={formData.openingBalance} // Bind the input value to the state
                              onChange={handleInputChange} // Handle the change event
                              style={{ width: "100%", height: "35px" }} // Additional styling if needed
                            ></Input>
                          </div>
                        </div>
                      </div>
                      <div className=" w-full">
                        <div>
                          <div className="w-full flex flex-col gap-y-1">
                            <div className="text-14 font-400">Payment Date</div>
                            <div className="flex items-center bg-white   datePicker_container ">
                              <DatePicker
                                selected={OpeningBalanceDate}
                                onChange={onChange}
                                paymentDate={OpeningBalanceDate}
                                // endDate={endDate}
                                // selectsRange
                                placeholderText={placeholder}
                                dateFormat={displayFormat}
                                className=" w-[100%] flex-grow  rounded focus:outline-hidden focus:ring-0    active:border active:border-DFE2E5 text-gray-800 text-sm  h-[34px]  border border-gray-200"
                              ></DatePicker>

                              <div>
                                <CalendarWithTimeIcon></CalendarWithTimeIcon>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
            <div className="text-14 font-400 flex justify-between items-center">
              <div>
                <button className="text-16 font-500 flex flex-col items-center justify-center text-center">
                  <div className="text-2999BC">Privacy</div>
                </button>
              </div>
              <div className="flex ">
                <div>
                  <Button type="primary" onClick={handleVendorCancel} style={{ margin: "10px" }}>
                    CANCEL
                  </Button>
                </div>
                <div>
                  <Button type="secondary" onClick={handleVendorSave} style={{ margin: "10px" }}>
                    SAVE
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NewVendor;
